module.exports = __webpack_public_path__ + "static/media/sauraj_dumps.2b9b680b.png";